// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ef-0";